/**
 * Initializes Swiper on mobile card gallery elements (product card image carousels).
 * Only inits when viewport is mobile (<=749px) so hidden desktop containers are skipped.
 *
 * @param {Document|Element} [root] - Root to search; defaults to document.
 * @returns {boolean} - True if Swiper was available and init ran (or no elements to init).
 */
function initCardGalleryMobileSwipers(root) {
  root = root || (typeof document !== "undefined" ? document : null);
  if (!root) return true;
  if (
    typeof window !== "undefined" &&
    window.matchMedia("(min-width: 750px)").matches
  )
    return true;

  const scope = root instanceof Document ? root.documentElement : root;
  const els = scope.querySelectorAll(
    "[data-card-gallery-mobile-swiper]:not([data-swiper-initialized])",
  );
  if (!els.length) return true;

  const Swiper = typeof window !== "undefined" ? window.Swiper : null;
  if (!Swiper) return false;

  els.forEach(function (el) {
    try {
      var swiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: "fade",
        fadeEffect: { crossFade: true },
        allowTouchMove: true,
        grabCursor: false,
        resistanceRatio: 0.85,
        watchOverflow: true,
        loop: true,
        threshold: 5,
      });
      el.setAttribute("data-swiper-initialized", "true");
      el._cardGalleryMobileSwiper = swiper;

      var timer = el.querySelector(".card-gallery-mobile__timer");
      if (timer) {
        var dashes = timer.querySelectorAll(".card-gallery-mobile__timer-dash");
        function updateDashes() {
          var idx =
            typeof swiper.realIndex !== "undefined"
              ? swiper.realIndex
              : swiper.activeIndex;
          dashes.forEach(function (dash, i) {
            dash.setAttribute("data-filled", i <= idx ? "true" : "");
          });
        }
        swiper.on("slideChange", updateDashes);
        updateDashes();
      }
    } catch (e) {
      console.warn("Card gallery Swiper init error:", e);
    }
  });
  return true;
}

function loadSwiperThenInit(callback) {
  if (window.Swiper) {
    callback();
    return;
  }
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
  document.head.appendChild(link);
  var script = document.createElement("script");
  script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
  script.async = true;
  script.onload = callback;
  document.head.appendChild(script);
}

function runInit() {
  if (!window.matchMedia("(max-width: 749px)").matches) return;
  loadSwiperThenInit(function () {
    initCardGalleryMobileSwipers(document);
  });
}

if (typeof window !== "undefined") {
  window.initCardGalleryMobileSwipers = initCardGalleryMobileSwipers;
}

if (typeof document === "undefined") {
  // no-op in SSR
} else if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runInit);
  window.addEventListener("load", function () {
    if (window.matchMedia("(max-width: 749px)").matches && window.Swiper) {
      initCardGalleryMobileSwipers(document);
    }
  });
} else {
  runInit();
  window.addEventListener("load", function () {
    if (window.matchMedia("(max-width: 749px)").matches && window.Swiper) {
      initCardGalleryMobileSwipers(document);
    }
  });
}

window.addEventListener("resize", function () {
  if (window.matchMedia("(max-width: 749px)").matches) {
    if (window.Swiper) {
      initCardGalleryMobileSwipers(document);
    } else {
      loadSwiperThenInit(function () {
        initCardGalleryMobileSwipers(document);
      });
    }
  }
});
